var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Icon__StyledIcon-sc-1det6wr-0 hfsbPz",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.95 8.61l.085.073 2.782 2.921c.219.22.24.537.065.732l-.066.06-2.781 2.922a.554.554 0 01-.426.182c-.329 0-.56-.197-.602-.503L17 14.891V12.9h-3a.9.9 0 01-.893-.787L13.1 12a.9.9 0 01.9-.9l3-.001v-1.99c0-.122.06-.305.183-.426a.585.585 0 01.766-.072zm-10.1 0l.085.073 2.782 2.921c.219.22.24.537.065.732l-.066.06-2.781 2.922a.554.554 0 01-.426.182c-.329 0-.56-.197-.602-.503l-.007-.106V12.9l-3 .001a.9.9 0 01-.893-.787L3 12a.9.9 0 01.787-.893L3.9 11.1l3-.001v-1.99c0-.122.06-.305.183-.426a.585.585 0 01.766-.072z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiCity);
export default __webpack_public_path__ + "static/media/multiCity.00df0d94a4cc2b5121184d10cc75a6ca.svg";
export { ForwardRef as ReactComponent };